import { LoaderContainer } from './styles';

const Loader = () => {
  return (
    <LoaderContainer>
      <div></div>
      <div></div>
      <div></div>
    </LoaderContainer>
  );
};

export default Loader;
